import { Icon } from "@chakra-ui/react"
import { FaBook } from "react-icons/fa"
import { useAppSelector } from "../../app/hooks"
import MeterBar from "../../components/MeterBar"
import {
  selectGameEducation,
  selectLastTurnEducationEffect,
  selectLastTurnNonce,
} from "./gameSlice"

// Hoisted so the memoised MeterBar sees a stable icon prop
const ICON = <Icon boxSize={6} as={FaBook} />

export const EducationMeter = () => {
  const value = useAppSelector(selectGameEducation)
  const effect = useAppSelector(selectLastTurnEducationEffect)
  const nonce = useAppSelector(selectLastTurnNonce)

  return (
    <MeterBar
      label="Education"
      value={value}
      max={100}
      icon={ICON}
      effect={effect}
      nonce={nonce}
    />
  )
}
